/**
 * Whether people can open a profile's page (the asset graph's G8a, docs/PLAN-asset-graph-20261011.md G-F): the Profile
 * button on a thread's people, the addresses on an email in the viewer, and the People page's entry in the account menu
 * (/people, the contacts book: docs/PLAN-assets-everywhere-20261025.md AE14a). The one lever:
 * `REACT_APP_PROFILES_ACCOUNTS`, a list of workspace ids where `*` admits every resolved workspace. Off when absent;
 * deploy.yml ships it as `*` (`vars.PROFILES_ACCOUNTS` narrows or, naming no workspace, turns it off). The profiles
 * themselves are decided on the server (`ops/assets.profiles`, and `profiles.view` on the person's member record), which
 * answers `off` or `not-allowed` whatever this says: hiding the ways in hides only where people open a page.
 */
import { buildEnv } from '../../config/buildEnv';

export const PROFILES_ACCOUNTS_ENV = 'REACT_APP_PROFILES_ACCOUNTS';

export function profilesShow(
  accountId: string | null | undefined,
  env: Record<string, string | undefined> = buildEnv(),
): boolean {
  const account = String(accountId ?? '').trim();
  if (!account) return false;
  const listed = String(env[PROFILES_ACCOUNTS_ENV] ?? '').split(',').map((s) => s.trim());
  return listed.includes('*') || listed.includes(account);
}
